import React from "react";
import styled, { css } from "styled-components";
import theme from "../../../assets/theme";
import { statusColor } from "../utils/statusHelpers";

const sizes = {
  sm: css`font-size: 10px; padding: 2px 8px;`,
  md: css`font-size: 11px; padding: 3px 10px;`,
};

const Pill = styled.span`
  display: inline-block;
  background: ${({ $bg }) => $bg};
  color: ${({ $text }) => $text};
  border: 1px solid ${({ $bd }) => $bd};
  border-radius: 8px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  ${({ $size }) => sizes[$size] || sizes.md}
`;

const StatusPill = ({ status, size = "md" }) => {
  const s = statusColor(status);
  return (
    <Pill $size={size} $bg={s.bg} $text={s.text} $bd={s.bd}>
      {s.label}
    </Pill>
  );
};

export default StatusPill;
